export const validateParamURL = (colors, sendTo, history, colorParamValue) => {
  
  const colorMaxValue = colors.length
  const selectedColorParamValue = parseInt(colorParamValue) + 1

  if (selectedColorParamValue > colorMaxValue || selectedColorParamValue <= 0) {
    history.push(sendTo)

    return true
  }
  return false

}